export const environment = {
  inputCompiled: false,
  production: true,
  baseEndpoint: "https://api.blogai.colibryx.com",
  priceId: "price_1MazlaHK2dOHMCSswXiKYSfM"
};
